import React, { useState, useEffect } from "react";
import { addAdmitCard, deleteAdmitCard } from "../../api/api";
import { useGlobalData } from "../../context/GlobalDataContext";
import "./AdminPanel.css";

function AdmitCardAdminPanel() {
  const { threeTable, fetchThreeTable } = useGlobalData();
  const [admitCards, setAdmitCards] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [formData, setFormData] = useState({ jobSlug: "" });
  const role = localStorage.getItem("role");

   useEffect(() => {
    if (!threeTable?.jobs?.length || !threeTable?.admitCards?.length) {
      fetchThreeTable();
    }
  }, [threeTable?.jobs?.length, threeTable?.admitCards?.length, fetchThreeTable]);

  // context -> local sync
  useEffect(() => {
    setJobs(threeTable.jobs || []);
    setAdmitCards(threeTable.admitCards || []);
  }, [threeTable.jobs, threeTable.admitCards]);
  
  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    await addAdmitCard(formData);
    alert("Admit Card added!");
    setFormData({ jobSlug: "" });
    await fetchThreeTable();
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this admit card?")) {
      await deleteAdmitCard(id);
      alert("Admit Card deleted!");
      await fetchThreeTable();
    }
  };

  const getJobTitle = (jobSlug) => jobs.find((job) => job.slug === jobSlug)?.title || jobSlug;
  const filteredAdmitCards = admitCards.filter(
    (admitCard) => !formData.jobSlug || admitCard.jobSlug === formData.jobSlug
  );

  if (role !== "superadmin") {
    return (
      <div className="admin-panel-error">❌ Access denied! Only Superadmin can access this panel.</div>
    );
  }

  return (
    <div className="resource-admin-panel resource-admin-panel--orange">
      <div className="resource-admin-panel__header">
        <div>
          <h2 className="resource-admin-panel__heading">Admit Card Admin Panel</h2>
          <p className="resource-admin-panel__subtext">Job select karke admit card entry add karo, recent entries review karo aur live page ko direct open ya delete kar sakte ho.</p>
        </div>
        <div className="resource-admin-panel__pill">Admit Card</div>
      </div>

      <form className="resource-admin-panel__form" onSubmit={handleSubmit}>
        <div className="resource-admin-panel__field">
          <label className="resource-admin-panel__label">Select Job</label>
          <p className="resource-admin-panel__hint">Jo job yahan select hogi usi job ke liye admit card record save hoga.</p>
          <select
            className="resource-admin-panel__select"
          value={formData.jobSlug}
          onChange={(e) => setFormData({ ...formData, jobSlug: e.target.value })}
        >
          <option value="">Select Job</option>
          {jobs.map((job) => (
            <option key={job._id} value={job.slug}>
              {job.title} ({job.slug})
            </option>
          ))}
        </select>
        </div>
        <button className="resource-admin-panel__submit" type="submit">Add Admit Card</button>
      </form>

      <div className="resource-admin-panel__section">
        <div className="resource-admin-panel__section-top">
          <div>
            <h3 className="resource-admin-panel__section-title">Saved Admit Cards</h3>
            <p className="resource-admin-panel__section-meta">{filteredAdmitCards.length} items {formData.jobSlug ? `for ${formData.jobSlug}` : "across all jobs"}</p>
          </div>
        </div>

        {filteredAdmitCards.length === 0 ? (
          <p className="resource-admin-panel__empty">Abhi selected filter ke liye koi admit card entry nahi hai.</p>
        ) : (
          <div className="resource-admin-panel__list">
            {filteredAdmitCards.slice(0, 15).map((admitCard) => {
              const isPending = admitCard.status === "pending";
              const statusColor = isPending ? "#f7b500" : "#2ecc40";
              return (
                <div key={admitCard._id} className="resource-admin-panel__item" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                  <div>
                    <p className="resource-admin-panel__item-title">{getJobTitle(admitCard.jobSlug)}</p>
                    <p className="resource-admin-panel__item-subtitle">Slug: {admitCard.jobSlug}</p>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{
                      background: statusColor,
                      color: '#fff',
                      borderRadius: 6,
                      padding: '2px 10px',
                      fontWeight: 600,
                      fontSize: 13
                    }}>{admitCard.status === "pending" ? "Pending" : "Approved"}</span>
                    <a href={`/mform/${admitCard.jobSlug}`} target="_blank" rel="noopener noreferrer" className="resource-admin-panel__link">
                      View Admit Card
                    </a>
                    <button
                      type="button"
                      className="resource-admin-panel__delete"
                      onClick={() => handleDelete(admitCard._id)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default AdmitCardAdminPanel;
